module.exports = __webpack_public_path__ + "img/Schoenen_verplicht.af39f69b.jpg";